import React, { useState, useEffect } from "react";
import { GoogleMap, useLoadScript, Marker } from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "400px"
};

const libraries = ["places"];

const StaticAddressMap = ({ apiKey, language, addressLocation }) => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: apiKey,
    libraries,
    language
  });
  const [selectedAddress, setSelectedAddress] = useState(addressLocation);

  useEffect(() => {
    setSelectedAddress(addressLocation);
  }, [addressLocation]);

  if (loadError || !isLoaded || !addressLocation || !addressLocation.lat || !addressLocation.lng) {
    return <div></div>;
  }

  const mapOptions = {
    draggable: false,
    scrollwheel: true,
    zoomControl: true,
    disableDefaultUI: true,
    keyboardShortcuts: false,
    disableDoubleClickZoom: true
  };

  return (
    <div>
      <GoogleMap mapContainerStyle={containerStyle} center={selectedAddress} zoom={15} options={mapOptions}>
        <Marker position={selectedAddress} />
      </GoogleMap>
    </div>
  );
};

export default StaticAddressMap;
